module.exports = __webpack_public_path__ + "img/pptx.cf19e0fa.png";